import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Header, MobileTabBar } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import Find from "@/pages/Find";
import Audit from "@/pages/Audit";
import Opportunities from "@/pages/Opportunities";
import BuyWhen from "@/pages/BuyWhen";
import Benefits from "@/pages/Benefits";
import Notes from "@/pages/Notes";
import Pro from "@/pages/Pro";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import CategoryPage from "@/pages/CategoryPage";
import Recommend from "@/pages/Recommend";
import Hungry from "@/pages/Hungry";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <main className="pb-24 md:pb-0 relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/find" element={<Find />} />
              <Route path="/audit" element={<Audit />} />
              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/life/:slug" element={<CategoryPage />} />
              <Route path="/buy-when" element={<BuyWhen />} />
              <Route path="/benefits" element={<Benefits />} />
              <Route path="/notes" element={<Notes />} />
              <Route path="/pro" element={<Pro />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/recommend" element={<Recommend />} />
              <Route path="/hungry" element={<Hungry />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
            </Routes>
          </main>
          <Footer />
          <MobileTabBar />
          <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#141217", border: "1px solid rgba(255,255,255,0.12)", color: "#F4EEE5", borderRadius: 0, fontFamily: "IBM Plex Mono, monospace", fontSize: "12px" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
